import gql from "graphql-tag";
import { ReceiverInfoFragment } from "domains/Task/graphql/fragments";

// eslint-disable-next-line import/prefer-default-export
export const ADD_RECEIVER = gql`
  mutation addReceiver($input: ReceiverAddInput!) {
    addReceiver(input: $input) {
      message
      code
      error
      data {
        ...ReceiverInfo
      }
    }
  }
  ${ReceiverInfoFragment}
`;


export const UPDATE_RECEIVER = gql`
  mutation updateReceiver($input: ReceiverUpdatingInput!) {
    updateReceiver(input: $input) {
      message
      code
      error
      data {
        ...ReceiverInfo
      }
    }
  }
  ${ReceiverInfoFragment}
`;

export const DELETE_RECEIVER = gql`
  mutation deleteReceiver($input: ReceiverDeleteInput!) {
    deleteReceiver(input: $input) {
      code
      error
      message
      data
    }
  }
`;